import { v4 } from 'uuid'
import {
  AccountDTO,
  AccountInterface,
  Address,
  BusinessUnitDTO,
  BusinessUnitDTOV2,
  BusinessUnitInterface,
  ApplicationDjangoDto,
  CategoryDjangoDto,
  CCWIntegracionV2,
  CategoryDto,
  LocationDjangoDto,
  ServiceDjangoDto,
  StoreDjangoDto,
  ContentDescription,
  DeliveryEnum,
  DestinationDTO,
  DestinationInterface,
  IntegrationInterfase,
  LocationInterface,
  PaymentModeEnum,
  PaymentModeId,
  PieceCategoryInterface,
  PieceInterface,
  PreShipmentInterface,
  PreshipmentDto,
  PreshipmentV2Dto,
  ShipmentDetail,
  ShipmentDTO,
  ShipmentInterface,
  ShipmentResponseSearchDto,
  ShipmentStatusEnum,
  ShippingMethodEnum,
  StoreShipmentInterface,
  TrackingEnum,
  UpdStarStandUserInterfase,
  UseAccountDto,
  UserAccountsInterfase,
} from '../interfaces'
import { ShipmentDtoV2 } from '../interfaces/Shipment/ShipmentDtoV2'
import { WeightTypeEnum } from '../interfaces/Shipment/WeightTypeEnum'
import { ImportInterface } from '../interfaces/Import/importInterfase'
import { LocationDto } from '../interfaces/Dto/LocationDto'
import { BUByLocationDto } from '../interfaces/Location/LocationByBu'
import { ServiceDTO } from '../interfaces/Services/Services'
import { formantPaymentModeId } from './format'
import moment from 'moment'
import { ShipmentService } from '../interfaces/Services/ServicesEnum'
import { InventoryItemDto } from '../interfaces/Inventory/InventoryItemDto'
import { InventoryApiProduct } from '../interfaces/Inventory/InventoryQuery'

// --- Inventory mappers ---
export const InventoryItemMapperDto = (
  dto: InventoryApiProduct
): InventoryItemDto => {
  return {
    Id: dto.product_id?.toString?.() ?? '',
    Name: dto.product_name ?? '',
    Code: dto.default_code ?? '',
    Count: Number(dto.quantity_available ?? 0),
    Weight: Number(dto.weight ?? 0),
    Volume: Number(dto.volume ?? 0),
    Length: Number(dto.length ?? 0),
    Width: Number(dto.width ?? 0),
    Height: Number(dto.height ?? 0),
    DeclareValues: Number(dto.standard_price ?? 0),
    CategoryName: dto.tags ? dto.tags.replace(/\['|'\]|\["|"\]/g, '') : '',
  }
}

export const businessUnitMapper = (
  dto: BusinessUnitDTO
): BusinessUnitInterface => {
  return {
    buid: dto.buid,
    buName: dto.buName,
    buArea: dto.buAreaName ?? '',
    buCode: dto.buCode,
    polygonList: dto.polygonList,
    location: {
      name: dto.buAreaName ?? '',
      code: dto.buCode,
      address: dto.address ?? '',
      locationCode: dto.locationCode ?? '',
      reference: dto.reference,
      postalCode: dto.postalCode ?? '',
      coordinates: {
        lat: !!dto.latitude ? +dto.latitude : 0,
        lng: !!dto.longitude ? +dto.longitude : 0,
      },
    },
  }
}

export const accountMapper = (dto: AccountDTO): AccountInterface => {
  return {
    id: dto.id ?? dto.AccountID,
    accountCode: dto.accountCode,
    taxIdentificationTypeID: dto.taxIdentificationTypeID,
    taxIdentificationTypeCode: dto.taxIDentificationTypeCode,
    agreementId: dto.agreementId,
    agreementID: dto.agreementID,
    abbreviationName: dto.abreviationName,
    cityName: dto.cityName,
    cityCode: dto.cityCode,
    identificationNumber: dto.identificationNumber,
    accountFullName: dto.accountFullName,
    fiscalAddress: dto.fiscalAddress,
    listAccountPhone: dto.listAccountPhone,
    listAccountEmail: dto.listAccountEmail,
    listAuthorizingAccount: dto.listAuthorizingAccount,
    creationUser: dto.creationUser,
    creationDate: dto.creationDate,
    accountSiteID: dto.accountSiteId,
    accountBillToId: dto.accountBillToId,
    contactPerson: dto.contactPerson,
    serviceID: dto.serviceID,
    isValueDeclare: dto.isValueDeclare,
    displayName: dto.displayName,
  }
}

export const destinationMapper = (
  dto: DestinationDTO
): DestinationInterface => {
  return {
    account: {
      id: dto.accountID,
      accountCode: dto.accountCode,
      abbreviationName: dto.abbreviationName,
      identificationNumber: dto.identificationNumber,
      accountFullName: dto.accountFullName,
      fiscalAddress: '',
      displayName: dto.displayName,
      listAccountPhone: [
        {
          id: dto.accountPhoneID,
          accountId: dto.accountID,
          countryId: dto.accountPhoneCountryID,
          countryPhoneAccessCode: dto.accountCountryPhoneAccessCode,
          phoneTypeId: dto.accountPhoneTypeID,
          phoneNumber: dto.accountPhoneNumber,
        },
      ],
      listAccountEmail: [],
      listAuthorizingAccount: [],
    },
    location: {
      id: dto.locationID,
      name: dto.addressName,
      address:
        dto.addressLine1 + (!!dto.addressLine2 ? ' ' + dto.addressLine2 : ''),
      reference: dto.addressReference,
      postalCode: dto.postalCode,
      coordinates: {
        lat: 0,
        lng: 0,
      },
    },
    businessUnit: businessUnitMapper(dto.businessUnit),
    isHomeDelivery: dto.isHomeDelivery,
  }
}

export const PreshipmentMapper = (
  dto: PreshipmentDto
): PreShipmentInterface => {
  return {
    id: dto.preShipmentHeaderID,
    shipmentNumber: dto.preShipmentNumber,
    service: dto.serviceCode,
    totalPieces: dto.totalPieces,
    totalWeight: dto.totalPhysicalWeight,
    deliveryType: dto.deliveryType as DeliveryEnum,
    shippingMethod: dto.shippingMethod as ShippingMethodEnum,
    sender: {
      fullName: '',
    },
    shipper: {
      id: v4(),
      accountCode: dto.accountCode,
      identificationNumber: dto.shipperIdentification,
      accountFullName: dto.shipperName,
      fiscalAddress: dto.shipperAddress,
      abbreviationName: dto.shipperName,
      listAccountPhone: [],
      listAccountEmail: [],
      listAuthorizingAccount: [],
      cityCode: dto.shipperCity ?? '',
    },
    consignee: {
      id: v4(),
      accountCode: dto.accountCode,

      identificationNumber: dto.consigneeIdentification,
      accountFullName: dto.consigneeName,
      fiscalAddress: dto.consigneeAddress,
      abbreviationName: dto.consigneeIdentificationType,
      listAccountPhone: [],
      listAccountEmail: [],
      listAuthorizingAccount: [],
      cityCode: dto.consigneeCity ?? '',
    },
    isSED: dto.isSED,
    isFragile: dto.isFragile,
    isPreAlerted: dto.isPreAlerted,
    isRepacke: dto.isRepackage,
    isSafeKeeping: dto.isSafeKeeping,
    isToHold: dto.isToHold,

    status: dto.statusName as ShipmentStatusEnum,
    shippingLocation: {
      name: dto.shipperLocation ?? '',
      code: dto.shipperLocationCode ?? '',
      address: dto.shipperAddress,
      postalCode: '',
      coordinates: {
        lat: 0,
        lng: 0,
      },
    },
    consigneeLocation: {
      name: dto.consigneeLocation ?? '',
      code: dto.consigneeLocationCode ?? '',
      address: dto.consigneeAddress,
      postalCode: '',
      coordinates: {
        lat: 0,
        lng: 0,
      },
    },
    businessUnitOrigin: {
      buid: 0,
      buName: dto.buCodeSourceName,
      buCode: dto.buCodeSource,
      buArea: '',
      location: {
        name: '',
        address: '',
        postalCode: '',
        coordinates: {
          lat: 0,
          lng: 0,
        },
      },
    },
    businessUnitConsignee: {
      buid: 0,
      buName: dto.buCodeConsigneeName,
      buCode: dto.buCodeConsignee,
      buArea: '',
      location: {
        name: '',
        address: '',
        postalCode: '',
        coordinates: {
          lat: 0,
          lng: 0,
        },
      },
    },
    number: 0,
  }
}

export const CategoryMapper = (dto: CategoryDto): PieceCategoryInterface => {
  return {
    id: dto.categoryID.toString(),
    name: dto.categoryName,
    code: dto.categoryCode,
  }
}

// --- Mappers API Django (carga masiva) ---
// Convierten los DTOs de REACT_APP_URL_PATH_API_DJANGO a las interfaces internas
// existentes para no propagar el shape Django al resto del front.

export const categoryDjangoToPieceCategory = (
  dto: CategoryDjangoDto
): PieceCategoryInterface => {
  return {
    id: dto.category_id.toString(),
    name: dto.category_name,
    code: dto.category_code,
  }
}

// Combina y deduplica listas de categorias (nacional type=1 + internacional type=2).
// Dedupe por id (fallback code/name). Funcion pura -> testeable sin tocar servicios.
export const mergeBulkCategories = (
  lists: PieceCategoryInterface[][]
): PieceCategoryInterface[] => {
  const seen = new Set<string>()
  const merged: PieceCategoryInterface[] = []
  lists.forEach((list) => {
    list.forEach((cat) => {
      const key = cat.id || cat.code || cat.name
      if (key && !seen.has(key)) {
        seen.add(key)
        merged.push(cat)
      }
    })
  })
  return merged
}

export const locationDjangoToLocationDto = (
  dto: LocationDjangoDto
): LocationDto => {
  return {
    locationID: dto.location_id?.toString(),
    locationCode: dto.location_code ?? '',
    locationName: dto.location_name,
  }
}

// Django /api/service/* → ServiceDTO interno. min_weight/max_weight llegan como string
// decimal ("70.00"): se convierten a number (undefined si no vienen o no parsean, que es
// como el consumidor —service-weight-limits— trata "sin limite").
export const serviceDjangoToServiceDTO = (
  dto: ServiceDjangoDto
): ServiceDTO => {
  // Los pesos llegaban como STRING decimal ("70.00") y ahora llegan como número.
  // Se aceptan ambos: `String(v)` normaliza antes de parsear.
  const num = (v: string | number | null | undefined): number | undefined => {
    if (v === null || v === undefined || v === '') return undefined
    const n = parseFloat(String(v))
    return isNaN(n) ? undefined : n
  }

  return {
    serviceID: dto.service_id,
    masterServiceID: dto.master_service ?? 0,
    serviceCode: dto.service_code,
    /**
     * `service_full_name` es el nombre nuevo; `service_description` el viejo.
     * Sin este fallback el campo quedaría `undefined` y los dropdowns de
     * servicio se verían VACÍOS — falla silenciosa, no error.
     */
    serviceDescription: dto.service_full_name ?? dto.service_description ?? '',
    serviceShortName: dto.service_short_name,
    serviceAbb: dto.service_abb,
    pickup: dto.pickup ?? false,
    receptionInBU: dto.reception_in_bu ?? false,
    minWeight: num(dto.min_weight),
    maxWeight: num(dto.max_weight),
    minTimeToDelivery: dto.min_time_to_deliver,
    maxTimeToDelivery: dto.max_time_to_deliver,
  }
}

// Django /api/location → BUByLocationDto (la tabla ciudad→tienda que usa la validacion/
// payload de carga masiva). Una fila por ciudad. Sustituye al mapeo del endpoint
// /api/business-unit-location (eliminado): la tienda ahora viene en
// default_destination_store. default_destination_store null = ciudad sin cobertura: se
// mapea a '' para que los `.find(c => c.buCode)` la traten como "sin tienda" (la validacion
// la marca "Ciudad sin tienda asignada", igual que antes).
export const locationDjangoToBUByLocationDto = (
  dto: LocationDjangoDto
): BUByLocationDto => {
  return {
    locationName: dto.location_name,
    locationCode: dto.location_code ?? '',
    bUName: dto.default_destination_store?.commercial_name ?? '',
    buCode: dto.default_destination_store?.code ?? '',
    locationID: dto.location_id,
    statusID: 0,
    statusName: '',
    status: '',
    creationUser: '',
    updateUser: '',
    message: '',
    messageCode: 0,
    bUByLocationScopeID: 0,
    lastUpdate: 0,
  }
}

// Django /api/store no trae buid numerico; se mapea buid: 0, asi que los consumidores de
// carga masiva deben dedupe/filtrar por buCode (unico), no por buid (ver
// businessUnitOptions en ShipmentBulkUpload).
//
// El TIPO de tienda si viaja, pero solo como nombre: `store_type_name` ("Junior",
// "Oficina Externa"). `store_type_id` es opcional en el DTO porque hoy el backend no lo
// manda, asi que `buTypeID` sigue quedando undefined y el filtro 10/20 de
// defaultCatalogOptions sigue sin aplicar a este catalogo — a proposito. El descarte de
// Junior se resuelve por nombre en `isJuniorStore` (utils/destinationBusinessUnits.ts).
export const storeDjangoToBUInterface = (
  dto: StoreDjangoDto
): BusinessUnitInterface => {
  const addr = dto.address
  return {
    buid: 0,
    buName: dto.commercial_name || dto.legal_name,
    buCode: dto.code,
    buTypeID: dto.store_type_id,
    storeTypeName: dto.store_type_name,
    buArea: addr?.location_name ?? '',
    polygonList: [],
    location: {
      name: addr?.location_name ?? '',
      code: dto.code,
      address: addr?.address_line1 ?? '',
      postalCode: addr?.postal_code ?? '',
      locationCode: addr?.location_code ?? '',
      coordinates: {
        lat: addr?.latitude ?? 0,
        lng: addr?.longitude ?? 0,
      },
    },
  }
}

function limitStringLength(value: string, maxLength: number): string {
  return value.length > maxLength ? value.substring(0, maxLength) : value
}

export const PreshipmentMapperDto = (
  dto: PreShipmentInterface
): PreshipmentV2Dto => {
  return {
    ServiceCode: String(dto.service?.toString() ?? 20),
    //ServiceID: parseInt(dto.service ?? ServiceEnum.CREDITO),
    CustomerCode: dto.customerCode,
    //totalWeight: dto.totalWeight ?? 0,
    PaymentModeID: dto.paymentModeID?.toString() ?? '3',
    DeliveryType: (dto.deliveryType as DeliveryEnum) ?? 2,
    ShippingMethod: (dto.shippingMethod as ShippingMethodEnum) ?? 0,
    PackageType: dto.packageType,
    MeasureUnitType: 10,
    ShipperCity: dto.shipper.cityCode,
    ConsigneeCity: dto.consignee.cityCode,
    BUCodeSource: dto.businessUnitOrigin?.buCode ?? 'NN', //FALTAN al logearse
    BUCodeConsignee: dto.businessUnitConsignee?.buCode,
    DeclaratedValue: dto.declaratedValue,
    ShipperIdentificationType: dto.sender?.abbreviationName,
    ShipperIdentification: dto.sender?.identificationNumber ?? '',
    ShipperName: limitStringLength(dto.sender?.fullName ?? '', 50),
    ConsigneeIdentificationType: dto.consignee.abbreviationName ?? '',
    ConsigneeIdentification: dto.consignee.identificationNumber,
    ConsigneeName: limitStringLength(dto.consignee.accountFullName, 50),
    ShipperAddress:
      dto.shipper.fiscalAddress ?? dto.shipper.businessUnit?.location.address,
    ShipperAddressLine2: '',
    ShipperPostalCode: '',
    ConsigneeAddressType: '10',
    ConsigneeAddress: dto.shippingLocation?.address,
    ConsigneeAddressLine2: '',
    ConsigneePostalCode: dto.shippingLocation?.postalCode,
    ShipperPhone: dto.shipper.listAccountPhone[0]?.phoneNumber,
    ShipperCellPhone: dto.shipper.listAccountPhone[1]?.phoneNumber,
    ShipperAcceptsSMS: dto.shipper.listAccountPhone[0]?.acceptsSMS,
    ConsigneePhone: dto.consignee.listAccountPhone[0]?.phoneNumber,
    ConsigneeCellPhone: dto.consignee.listAccountPhone[1]?.phoneNumber,
    ShipperEmailType: 2,
    ShipperEmail: dto.shipper.listAccountEmail[0]?.email,
    ConsigneeEmail: dto.consignee.listAccountEmail[0]?.email,
    ConsigneeContactPerson: dto.sender?.fullName,
    isFragile: dto.isFragile,
    IsSafeKeeping: dto.isSafeKeeping,
    IsRepackage: false,
    IsDelivery: false,
    ShipperAddressType: '10',
    ConsigneeAcceptsSMS: dto.consignee.listAccountPhone[0]?.acceptsSMS,
    ConsigneeEmailType: 2,
    UserLogin: 'ccw',
    Observations: dto.observations ?? '',
    ShipperLatitude: dto.shipper.businessUnit!.location.coordinates!.lat,
    ShipperLongitude: dto.shipper.businessUnit!.location.coordinates!.lng,
    ConsigneeLatitude: dto.shippingLocation?.coordinates.lat ?? 0,
    ConsigneeLongitude: dto.shippingLocation?.coordinates.lng ?? 0,
    DeclaratedValueInvoceNum: dto.declaratedValueInvoceNum,
    ContentDescription: dto.pieces?.map((dto: PieceInterface, index) =>
      PieceInterfaceMapper(dto, index)
    ),
    ShipmentDetail: dto.pieces?.map((dto: PieceInterface, index) =>
      PieceInterfaceDetailsMapper(dto, index)
    ),
  }
}

export const PieceInterfaceMapper = (
  dto: PieceInterface,
  index: number
): ContentDescription => {
  return {
    PieceNumber: index + 1,
    Height: dto.height ?? 0,
    Width: dto.width,
    Lenght: dto.length,
    PhysicalWeight: dto.weight,
    ProductCode: dto.category.code,
  }
}

export const PieceInterfaceDetailsMapper = (
  dto: PieceInterface,
  index: number
): ShipmentDetail => {
  return {
    PieceNumber: index + 1,
    Height: dto.height ?? 0,
    Width: dto.width,
    Lenght: dto.length,
    PhysicalWeight: dto.weight,
    DeclaratedValue: isNaN(dto.declaredValue) ? 0 : dto.declaredValue,
  }
}

export const ShipmentMapperDto = (dto: ShipmentInterface): ShipmentDtoV2 => {
  return {
    guideRequered: '1',
    ServiceID: parseInt(dto.service ?? '60') ?? 60,
    CustomerCode: dto.customerCode,
    PaymentModeID: parseInt(dto.paymentModeID ?? '3'),
    ShipperTaxIdentTypeID: dto.sender?.abbreviationId ?? 1,
    ConsigneeTaxIdentTypeID: dto.consignee.taxIdentificationTypeID ?? 1,
    ShipperCountry: 'VE',
    ConsigneeCountry: 'VE',
    CurrencyID: 1,
    DeclaratedValueCurrency: 'VES',
    AccountTypeID: 3,
    StatusID: 5,
    ShipperAccountID: dto.shipper.id,
    accountSiteId:
      dto.shipper.accountSiteID === 0 ? undefined : dto.shipper.accountSiteID,
    ConsigneeAddressLandMark: dto.consignee.reference,
    ShipperLatitude: dto.shipper.businessUnit!.location.coordinates!.lat,
    ShipperLongitude: dto.shipper.businessUnit!.location.coordinates!.lng,
    ConsigneeLatitude: dto.shippingLocation?.coordinates.lat ?? 0,
    ConsigneeLongitude: dto.shippingLocation?.coordinates.lng ?? 0,
    ShipmentHeaderReference: dto.trackingDetails,
    ConsigneeCountryID: dto.consignee.listAccountPhone[0]?.countryId ?? '253',
    WeightUnitID: (dto.weightUnit as WeightTypeEnum) ?? 10,
    //totalWeight: dto.totalWeight ?? 0,
    DeliveryTypeID: (dto.deliveryType as DeliveryEnum) ?? 2,
    ShippingMethodID: (dto.shippingMethod as ShippingMethodEnum) ?? 0,
    PackageTypeID: dto.packageType,
    MeasureUnitTypeID: 10,
    ShipperCity: dto.shipper.cityCode,
    ConsigneeCity: dto.consignee.cityCode,
    BUCodeSource: dto.businessUnitOrigin?.buCode ?? 'NN', //FALTAN al logearse
    BUCodeConsignee: dto.businessUnitConsignee?.buCode ?? '',
    DeclaratedValue: dto.declaratedValue,
    ShipperTaxIdentTypeCode: dto.sender?.abbreviationName,
    ShipperIdentificationNumber:
      dto.sender?.identificationNumber?.toString() ?? '',
    ShipperName: dto.sender?.fullName ?? '',
    ConsigneeTaxIdentTypeCode: dto.consignee.abbreviationName ?? '',
    ConsigneeIdentificationNumber:
      dto.consignee.identificationNumber?.toString(),
    ConsigneeName: dto.consignee.accountFullName,
    ShipperAddress:
      (dto.shipper.fiscalAddress ?? dto.shipper.businessUnit!.location.address)
        .length > 0
        ? (dto.shipper.fiscalAddress ??
          dto.shipper.businessUnit!.location.address)
        : 'N/A Tienda Virtual',
    ShipperAddressLine2: '',
    ShipperPostalCode: '',
    ConsigneeAddressName: dto.shippingLocation?.name ?? '',
    ConsigneeAddress: dto.shippingLocation?.address ?? '',
    ConsigneeAddressLine2: '',
    ConsigneePostalCode: dto.shippingLocation?.postalCode,
    ShipperPhone: dto.shipper.listAccountPhone[0]?.phoneNumber ?? '0000',
    ShipperCellPhone: dto.shipper.listAccountPhone[1]?.phoneNumber ?? '0000',
    ConsigneePhone: dto.consignee.listAccountPhone[0]?.phoneNumber,
    ConsigneeCellPhone: dto.consignee.listAccountPhone[1]?.phoneNumber,
    ShipperEmail:
      dto.shipper.listAccountEmail[0]?.email.length > 0
        ? dto.shipper.listAccountEmail[0]?.email
        : 'ccwGeneral@tealca.com',
    ConsigneeEmail:
      dto.consignee.listAccountEmail[0]?.email !== undefined &&
      dto.consignee.listAccountEmail[0]?.email.length > 0
        ? dto.consignee.listAccountEmail[0]?.email
        : 'ccwGeneral@tealca.com',
    ConsigneeContactPerson: dto.sender?.fullName ?? '',
    isFragile: dto.isFragile,
    IsSafeKeeping: dto.isSafeKeeping,
    IsRepackage: false,
    AcceptsSMS: dto.consignee.listAccountPhone[0]?.acceptsSMS,
    CreationUser: dto.creationUser,
    Observations: dto.observations ?? '',
    ApplicationId: 2,
    ContentDescription: dto.pieces?.map((dto: PieceInterface, index) =>
      PieceInterfaceMapper(dto, index)
    ),
    ShipmentDetail: dto.pieces?.map((dto: PieceInterface, index) =>
      PieceInterfaceDetailsMapper(dto, index)
    ),
    ExternalManfiest: dto.externalManfiest,
    AccountBillToID: dto.accountBillToID,
    DeclaratedValueInvoceNum: dto.declaratedValueInvoceNum,
  }
}

export const LocationMapperDto = (dto: Address): LocationInterface => {
  return {
    id: dto.addressID,
    name: dto.addressName,
    code: dto.addressShortCode,
    address: dto.addressLine1,
    postalCode: dto.postalCode,
    locationCode: dto.locationID.toString(),
    coordinates: {
      lat: dto.latitude,
      lng: dto.longitude,
    },
  }
}

export const ShipmentSearchMapperDto = (
  dto: ShipmentResponseSearchDto
): ShipmentInterface => {
  var consigne = accountMapper(dto.consignee as AccountDTO)
  consigne.fiscalAddress = dto.consigneeAddress.addressName
  consigne.countryName = dto.consigneeAddress.countryName

  return {
    id: dto.shipmentHeaderID,
    number: dto.shipmentNumber,
    service: dto.serviceID,
    paymentMode: formantPaymentModeId(
      dto.paymentModeID.toString() as PaymentModeId
    ) as PaymentModeEnum,
    deliveryTypeID: dto.deliveryTypeID,
    observations: dto.observations,
    totalPieces: dto.totalPieces,
    total: dto.totalAmount,
    totalWeight: dto.totalPhysicalWeight,
    totalDimensionalWeight: dto.totalDimensionalWeight,
    totalVolumeCf3: dto.totalDimensionalCF,
    consignee: consigne,
    buSource: dto.buSource,
    buConsignee: dto.buConsignee,
    consigneeAddress: {
      name: dto.consigneeAddress.addressName,
      address:
        dto.consigneeAddress.addressLine1 +
        (dto.consigneeAddress.addressLine2
          ? '. ' + dto.consigneeAddress.addressLine2
          : ''),
      postalCode: dto.consigneeAddress.postalCode,
      coordinates: {
        lat: dto.consigneeAddress.latitude,
        lng: dto.consigneeAddress.longitude,
      },
    },
    businessUnitOrigin: dto.buSource,
    businessUnitConsignee: dto.buConsignee,
    consigneeLocation: dto.buConsignee.location,
    statusName: dto.statusName,
    statusID: dto.statusID,
    creationDate: dto.creationDate,
    creationUser: dto.creationUser,
    tracking: TrackingEnum.TRACKING,
    trackingDetails: dto.shipmentHeaderReference,
    deliveryType: dto.deliveryTypeID as DeliveryEnum,
    shippingMethod: dto.shippingMethodID as ShippingMethodEnum,
    sender: {
      fullName: '',
      abbreviationName: '',
      identificationNumber: '',
      valueDeclarate: '',
    },
    shipper: accountMapper(dto.shipper),
    shippingLocation: dto.buSource.location,
    isHighValueCargo: false,
    isFragile: false,
    isSED: false,
    isToHold: false,
    isRepacke: false,
    isPreAlerted: false,
    isSafeKeeping: dto.isSafeKeeping,
    status: dto.statusName as ShipmentStatusEnum,
    externalManfiest: dto.externalManfiest,
    shipmentDetails: dto.shipmentDetails,
    declaratedValue: dto.declaratedValue,
    declaratedValueInvoceNum: dto.declaratedValueInvoceNum,
  }
}

export const ImportMapperDto = (dto: IntegrationInterfase): ImportInterface => {
  return {
    A: dto.date?.toString().trim() ?? '',
    B: dto.warehouse?.toString().trim() ?? '',
    C: '10',
    D: dto.consigneeCity?.toString().trim() ?? '',
    E: '',
    F: 'V',
    G: dto.shipperID?.toString().trim() ?? '',
    H: dto.shipper?.toString().trim() ?? '',
    I: 'V',
    J: dto.consigneeID?.toString().trim() ?? '',
    K: dto.consignee?.toString().trim() ?? '',
    L: dto.consigneePhone?.toString().trim() ?? '',
    M: dto.consigneeEmail?.toString().trim() ?? '',
    N: dto.consigneeAddress?.toString().trim() ?? '',
    O: '',
    P: 'Integracion CCW',
    Q: dto.pieces?.toString().trim() ?? '1',
    R: dto.chargeableWeight?.toString().trim() ?? '0',
    S: dto.height?.toString().trim() ?? '1',
    T: dto.width?.toString().trim() ?? '1',
    U: dto.length?.toString().trim() ?? '1',
    V: dto.paymentTerms?.toString().trim() ?? '0',
    W: '1',
    id: v4(),
  }
}

export const ImportMapperV2Dto = (dto: CCWIntegracionV2): ImportInterface => {
  return {
    A: dto.date?.toString().trim() ?? '',
    B: dto.shipmentNumber?.toString().trim() ?? '',
    C: dto.deliveryType?.toString().trim() ?? '',
    D: dto.consigneeCity?.toString().trim() ?? '',
    E: dto.consigneeBu?.toString().trim() ?? '',
    F: 'J',
    G: '',
    H: dto.shipperName?.toString().trim() ?? '',
    I: dto.consigneeDocumentType?.toString().trim() ?? '',
    J: dto.consigneeDocument?.toString().trim() ?? '',
    K: dto.consigneeName?.toString().trim() ?? '',
    L: dto.consigneePhone?.toString().trim() ?? '',
    M: dto.consigneeEmail?.toString().trim() ?? '',
    N: dto.consigneeAddress?.toString().trim() ?? '',
    O: dto.consigneePostal?.toString().trim() ?? '',
    P: dto.observation?.toString().trim() ?? '',
    Q: dto.pieces?.toString().trim() ?? '1',
    R: dto.grossWeight?.toString().trim() ?? '0',
    S: dto.height?.toString().trim() ?? '1',
    T: dto.width?.toString().trim() ?? '1',
    U: dto.length?.toString().trim() ?? '1',
    V: dto.declaratedValue?.toString().trim() ?? '0',
    W: dto.categoryType?.toString().trim() ?? '0',
    id: v4(),
  }
}

export const mapBUDtoToBUInterface = (
  businessUnit: BusinessUnitDTOV2
): BusinessUnitInterface => {
  return {
    buid: businessUnit.buid,
    buName: businessUnit.buName,
    buCode: businessUnit.buCode,
    buArea: businessUnit.buAreaName ?? '',
    location: {
      id: businessUnit?.locationID?.toString(),
      name: businessUnit.buAreaName ?? '',
      address: businessUnit.address ?? '',
      reference: businessUnit.addressLandMark ?? '',
      postalCode: businessUnit.postalCode ?? '',
      locationCode: businessUnit.locationCode,
      coordinates: {
        lat: !!businessUnit.latitude ? parseFloat(businessUnit.latitude) : 0,
        lng: !!businessUnit.longitude ? parseFloat(businessUnit.longitude) : 0,
      },
    },
    polygonList: businessUnit.polygonList ?? [],
    buTypeID: businessUnit.buTypeID,
    isLocked: businessUnit.isLocked,
  }
}

export const UserAccountMapperDto = (
  dto: UserAccountsInterfase
): UpdStarStandUserInterfase => {
  return {
    accountList: [
      {
        accountID: dto.accountID,
        accountSiteID: dto.accountSiteID,
        userAccountID: dto.id,
      },
    ] as UseAccountDto[],
    userID: dto.userID,
    departmentID: dto.departamentID,
    taxIdentificationTypeID: dto.userIdentificationTypeID ?? 0,
    userIdentificationNumber: dto.userIdentificationNumber,
    userName: dto.userName,
    userLastName: dto.userLastName,
    userEmail: dto.userEmail,
    userPhone: dto.userPhone,
    userLogin: dto.userLogin,
    userPassword:
      dto.userID === undefined
        ? 'Tealca' + moment().format('YYYY')
        : 'Tealca' + moment().format('YYYY'),
    passwordExpirationDate: moment().add(10, 'days').format('YYYY-MM-DD'),
    businessUnits: undefined,
    profilesList: [dto.profileID ?? 0],
    applicationCode: '020',
    StatusID: dto.statusID,
    AllAccountClient: dto.allAccountClient,
    creationUser: dto.createUser,
    updateUser: dto.updateUser,
  }
}

export const mapBusinessUnitDtoListToBusinessUnitInterface = (
  businessUnitDto: BusinessUnitDTO[]
): BusinessUnitInterface[] => {
  return businessUnitDto.map((businessUnit: BusinessUnitDTO) =>
    mapBUDtoToBUInterface(businessUnit)
  )
}

export const mapServiceToEnum = (
  service: string
): ShipmentService | undefined => {
  switch (service) {
    case '60':
      return ShipmentService.STANDARD
    case '61':
      return ShipmentService.DOCUMENT
    case '62':
      return ShipmentService.INTERNATIONAL
    case '64':
      return ShipmentService.ECONOMIC
    case '81':
      return ShipmentService.NATIONAL_LOCKER
  }
}

export const mapPreShipmentToStoreShipment = (
  preShipment: PreShipmentInterface
): StoreShipmentInterface => {
  return {
    shipmentHeaderID: preShipment.id,
    shipmentNumber: preShipment.shipmentNumber ?? '',
    creationDate: preShipment.date ?? new Date().toISOString(),
    shipmentHeaderDate: preShipment.date ?? new Date().toISOString(),
    paymentModeID: preShipment.paymentModeID
      ? Number(preShipment.paymentModeID)
      : 0,
    shipperName: preShipment.shipper?.accountFullName ?? '',
    shipperTaxIdentificationTypeID:
      preShipment.shipper?.taxIdentificationTypeID ?? 0,
    shipperIdentificationNumber:
      preShipment.shipper?.identificationNumber ?? '',
    shipperPhone: preShipment.shipper?.listAccountPhone?.[0]?.phoneNumber ?? '',
    buCodeSource: preShipment.businessUnitOrigin?.buCode ?? '',
    sourceBUAreaName: preShipment.businessUnitOrigin?.buArea ?? '',
    consigneeName: preShipment.consignee?.accountFullName ?? '',
    consigneeTaxIdentificationTypeID:
      preShipment.consignee?.taxIdentificationTypeID ?? 0,
    consigneeIdentificationNumber:
      preShipment.consignee?.identificationNumber ?? '',
    consigneePhone:
      preShipment.consignee?.listAccountPhone?.[0]?.phoneNumber ?? '',
    buCodeConsignee: preShipment.businessUnitConsignee?.buCode ?? '',
    consigneeBUAreaName: preShipment.businessUnitConsignee?.buArea ?? '',
    totalPieces: preShipment.totalPieces ?? 0,
    totalChargedWeight: preShipment.totalWeight ?? 0,
    totalDimensionalWeight: preShipment.totalDimensionalWeight ?? 0,
    totalPhysicalWeight:
      preShipment.totalPhysicalWeight ?? preShipment.totalWeight ?? 0,
    totalAmountBaseCurr: preShipment.totalAmount ?? 0,
    documentID: preShipment.id,
    documentNumber: preShipment.shipmentNumber ?? '',
    documentStatusID: preShipment.statusID ?? 0,
    documentTypeID: 0,
    consigneeAddressLandmark: preShipment.consigneeLocation?.reference ?? '',
    consigneeAddress: preShipment.consigneeLocation?.address ?? '',
    addressName: preShipment.consigneeLocation?.name ?? '',
    storePickup: '',
    lastBU: '',
    lbuBUAreaName: '',
    lastBUDate: '',
    statusID: preShipment.statusID ?? 0,
    statusName: preShipment.statusName ?? '',
    shipmentReference: '',
    serviceID: preShipment.service ?? '',
    serviceCode: preShipment.service ?? '',
    serviceShortName: '',
    locationName: preShipment.shippingLocation?.name ?? '',
  }
}

export const mapPaymentModeIdToEnum = (
  id: number
): PaymentModeEnum | undefined => {
  switch (id.toString()) {
    case PaymentModeId.COD:
      return PaymentModeEnum.COD
    case PaymentModeId.CONTADO:
      return PaymentModeEnum.CONTADO
    case PaymentModeId.CREDIT:
    case PaymentModeId.CREDITTAQUILLAORIGEN:
    case PaymentModeId.CREDITTAQUILLADESTINO:
      return PaymentModeEnum.CREDIT
    default:
      return undefined
  }
}

export const mapDeliveryTypeIdToEnum = (
  id: number
): DeliveryEnum | undefined => {
  switch (id?.toString()) {
    case DeliveryEnum.OFFICE:
      return DeliveryEnum.OFFICE
    case DeliveryEnum.DELIVERY:
      return DeliveryEnum.DELIVERY
    case DeliveryEnum.INTERNATIONAL:
      return DeliveryEnum.INTERNATIONAL
    default:
      return undefined
  }
}

export const mapShipmentStatusIdToEnum = (
  id: number
): ShipmentStatusEnum | undefined => {
  switch (id?.toString()) {
    case '5':
      return ShipmentStatusEnum.DRAFT
    case '1':
      return ShipmentStatusEnum.ACTIVE
    case '3':
      return ShipmentStatusEnum.ANNULLED
    case '55':
      return ShipmentStatusEnum.REPLACED
    case '30':
      return ShipmentStatusEnum.DELIVERED
    default:
      return ShipmentStatusEnum.DEFAULT
  }
}

export const mapShipmentDTOToInterface = (
  dto: ShipmentDTO
): ShipmentInterface => {
  const buConsignee: BusinessUnitInterface = {
    buid: parseInt(dto.buConsignee.buid),
    buCode: dto.buConsignee.buCode,
    buName: dto.buConsignee.buName,
    polygonList: [],
    buArea: dto.buConsignee.buAreaName,
    location: {
      name: dto.buConsignee.buAreaName,
      code: dto.buConsignee.buCode,
      address:
        dto.buConsignee.addressLine1 + '. ' + dto.buConsignee.addressLine2,
      postalCode: dto.buConsignee.postalCode,
      coordinates: {
        lat: 0,
        lng: 0,
      },
    },
  }

  return {
    id: dto.shipmentHeaderID,
    shipmentNumber: dto.shipmentNumber,
    service: dto.serviceID.toString(),
    paymentMode: mapPaymentModeIdToEnum(dto.paymentModeID),
    deliveryType:
      mapDeliveryTypeIdToEnum(dto.deliveryTypeID) ?? DeliveryEnum.OFFICE,
    pickupType: dto.pickupTypeID,
    lastBU: dto.lastBU,
    lastBUDate: dto.lastBUDate,
    observations: dto.observations,
    status: mapShipmentStatusIdToEnum(dto.statusID) ?? ShipmentStatusEnum.DRAFT,
    createdAt: dto.creationDate,
    updatedAt: dto.updateDate,
    total: dto.totalAmount,
    declaratedValue: dto.declaratedValue,
    declaratedValueInvoceNum: dto.declaratedValueInvoceNum,
    accountSiteID: dto.accountSiteID,
    substituteFor: dto.substituteFor,
    substitutedBy: dto.substitutedBy,
    totalChargedWeight: dto.totalChargedWeight,
    totalPhysicalWeight: dto.totalPhysicalWeight,
    totalDimensionalWeight: dto.totalDimensionalWeight,
    totalVolume: dto.totalVolume,
    dimensionalFactor: dto.dimensionalFactor,
    deliveryDate: dto.deliveryDate,
    deliveryDistance: dto.deliveryDistance,
    deliveryObservation: dto.deliveryObservation,
    deliveryCreationUser: dto.deliveryCreationUser,
    pickupDistance: dto.pickupDistance,
    totalPostalTaxBaseCurr: dto.totalPostalTaxBaseCurr,
    contactPerson: dto.consigneeContactPerson,
    document: !!dto.document
      ? {
          documentId: dto.document.documentID,
          documentNumber: dto.document.documentNumber,
          documentTypeID: dto.document.documentTypeID,
          status: dto.document.statusID,
          urlDocument: dto.document.urlDocument,
          creationDate: dto.document.creationDate,
          accountName: dto.document.accountName,
          totalAmountBaseCurr: dto.document.totalAmountBaseCurr,
          balanceAmountBaseCurr: dto.document.balanceAmountBaseCurr,
        }
      : undefined,

    shipper: {
      id: dto.shipper.accountID,
      accountCode: dto.shipper.accountCode,
      taxIdentificationTypeCode: dto.shipper.taxIDentificationTypeCode,
      taxIdentificationTypeID: dto.shipper.taxIdentificationTypeID,
      abbreviationName: dto.shipper.abreviationName,
      abreviationName: dto.shipper.abreviationName,
      identificationNumber: dto.shipper.identificationNumber,
      accountFullName: dto.shipper.accountFullName,
      listAccountPhone: [
        {
          phoneID: '',
          countryId: dto.shipper.listAccountPhone[0].countryID?.toString(),
          accountId: dto.shipper.accountID,
          phoneTypeId: '1',
          phoneNumber: dto.shipper.listAccountPhone[0].phoneNumber,
          countryPhoneAccessCode: undefined,
        },
      ],
      listAccountEmail: [
        {
          emailID: '',
          accountId: dto.shipper.accountID,
          emailTypeId: '1',
          email: dto.shipper.listAccountEmail[0].email,
        },
      ],
      listAuthorizingAccount: [],
    },

    consignee: {
      id: dto.consignee.accountID,
      accountCode: dto.consignee.accountCode,
      taxIdentificationTypeCode: dto.consignee.taxIDentificationTypeCode,
      taxIdentificationTypeID: dto.consignee.taxIdentificationTypeID,
      abreviationName: dto.consignee.abreviationName,
      abbreviationName: dto.consignee.abreviationName,
      identificationNumber: dto.consignee.identificationNumber,
      accountFullName: dto.consignee.accountFullName,
      listAccountPhone: [
        {
          phoneID: '',
          countryId: dto.consignee.listAccountPhone[0].countryID.toString(),
          accountId: dto.consignee.accountID,
          phoneTypeId: '1',
          phoneNumber: dto.consignee.listAccountPhone[0].phoneNumber,
          countryPhoneAccessCode: undefined,
        },
      ],
      listAccountEmail: [
        {
          emailID: '',
          accountId: dto.consignee.accountID,
          emailTypeId: '1',
          email: dto.consignee.listAccountEmail[0].email,
        },
      ],
      listAuthorizingAccount: [],
    },

    boxAccount: !!dto.boxAccountCode
      ? {
          id: '',
          boxAccountCode: dto.boxAccountCode,
          businessUnit: buConsignee,
          accountID: dto.consignee.accountID,
          accountFullName: dto.consignee.accountFullName,
          accountAbreviationName: dto.consignee.abreviationName,
          accountIdentificationNumber: dto.consignee.identificationNumber,
          authorizedShippers: [],
        }
      : undefined,

    accountBillTo: !!dto.accountBillTo
      ? {
          id: dto.accountBillTo.accountID,
          accountCode: dto.accountBillTo.accountCode,
          taxIdentificationTypeCode:
            dto.accountBillTo.taxIDentificationTypeCode,
          taxIdentificationTypeID: dto.accountBillTo.taxIdentificationTypeID,
          abreviationName: dto.accountBillTo.abreviationName,
          identificationNumber: dto.accountBillTo.identificationNumber,
          accountFullName: dto.accountBillTo.accountFullName,
          listAccountPhone: [],
          listAccountEmail: [],
          listAuthorizingAccount: [],
        }
      : undefined,

    buSource: {
      buid: parseInt(dto.buSource.buid),
      buCode: dto.buSource.buCode,
      buName: dto.buSource.buName,
      buArea: dto.buSource.buAreaName,
      polygonList: [],
      location: {
        name: dto.buSource.buAreaName,
        code: dto.buSource.buCode,
        address: dto.buSource.addressLine1 + '. ' + dto.buSource.addressLine2,
        postalCode: dto.buSource.postalCode,
        coordinates: {
          lat: 0,
          lng: 0,
        },
      },
    },

    buConsignee,

    consigneeAddress: {
      name: dto.consigneeAddress.addressName,
      code: dto.consigneeAddress.addressShortCode,
      address:
        dto.consigneeAddress.addressLine1 +
        (dto.consigneeAddress.addressLine2
          ? '. ' + dto.consigneeAddress.addressLine2
          : ''),
      postalCode: dto.consigneeAddress.postalCode,
      coordinates: {
        lat: dto.consigneeAddress.latitude,
        lng: dto.consigneeAddress.longitude,
      },
      reference: dto.consigneeAddress.landMark,
    },

    shipperAddress: !!dto.shipperAddress
      ? {
          name: dto.shipperAddress.addressName,
          code: dto.shipperAddress.addressShortCode,
          address:
            dto.shipperAddress.addressLine1 +
            (dto.shipperAddress.addressLine2
              ? '. ' + dto.shipperAddress.addressLine2
              : ''),
          postalCode: dto.shipperAddress.postalCode,
          coordinates: {
            lat: dto.shipperAddress.latitude,
            lng: dto.shipperAddress.longitude,
          },
          reference: dto.shipperAddress.landMark,
        }
      : undefined,

    pieces:
      dto.shipmentDetails?.map((detail) => ({
        id: detail.shipmentDetailID,
        weight: detail.physicalWeight,
        width: detail.width,
        height: detail.height,
        length: detail.lenght,
        declaredValue: detail.declaratedValue,
        pieceNumber: detail.pieceNumber,
        category: {
          id: String(detail.category.categoryID),
          code: detail.category.categoryCode,
          name: detail.category.categoryName,
        },
      })) ?? [],

    items:
      dto.shipmentItems?.map((item, index) => ({
        id: item.itemID.toString(),
        code: item.itemCode,
        name:
          item.couponValue === undefined
            ? item.itemName
            : item.itemName.replace('&&', (-item.couponValue).toString()),
        order: index,
        mandatory: true,
        isItemBase: item.isItemBase,
        couponID: item.couponID,
        couponValue: item.pctDiscount,
        rate: {
          value:
            (item.itemID === 31 ||
              item.itemID === 3010 ||
              item.itemID === 3020) &&
            !dto.document
              ? item.pctDiscount
              : item.totalAmount,
          isPercentage:
            item.itemID === 31 && item.totalAmount === 0 ? true : false,
          iva: item.taxAmount,
          distance: 0,
          ipostel: 0,
          tierCode: dto.rateTier,
          tierName: dto.tierName,
        },
      })) ?? [],

    //Extras
    tracking: TrackingEnum.PENDING,
    creationUser: dto.creationUser ?? '',
    isHighValueCargo: false,
    number: parseInt(dto.shipmentNumber ?? '0'),
    shippingMethod: ShippingMethodEnum.SEA,
    sender: undefined,
    shippingLocation: undefined,
    businessUnitOrigin: undefined,
    businessUnitConsignee: undefined,
    isSED: false,
    isToHold: false,
    isFragile: false,
    isRepacke: false,
    isPreAlerted: false,
    isSafeKeeping: dto.isSafeKeeping ?? false,
    externalManifest: dto.externalManifiest,
    shipmentHeaderReference: dto.shipmentHeaderReference ?? '',
  }
}

/**
 * Abreviatura de tipo de documento ("V-", "J-", "v") → `taxIdentificationTypeId`.
 *
 * El backend Django dejó de mandar el ID numérico y ahora manda la abreviatura lista
 * para mostrar (GET /shipment y GET /account/{id}/destinations). Adentro, en cambio,
 * `RecurrentDestinationInterface` y `ShipmentGroup.consigneeDocType` siguen siendo
 * numéricos y los comparten con la ruta .NET legacy, así que la conversión va acá, en
 * el borde, y no se propaga.
 *
 * Normaliza guion final y mayúsculas porque el catálogo y la API no coinciden siempre
 * ("V-" contra "V"). Devuelve 0 si no matchea: es el mismo "sin tipo" que ya usaban los
 * llamadores, y sirve para detectar un catálogo desincronizado sin romper la fila.
 */
export const taxIdTypeIdFromAbbreviation = (
  abbreviation: string | null | undefined,
  taxIdTypes: { abbreviationName?: string; taxIdentificationTypeId?: number }[]
): number => {
  const needle = (abbreviation || '').replace(/-+$/, '').trim().toUpperCase()
  if (!needle) return 0
  const found = taxIdTypes.find(
    (t) => (t.abbreviationName || '').replace(/-+$/, '').trim().toUpperCase() === needle
  )
  return found?.taxIdentificationTypeId ?? 0
}
